import { cn } from '@/lib/utils';
import { getLinkAttributes } from '@platejs/link';
import { useLink } from '@platejs/link/react';
import type { TLinkElement } from 'platejs';
import type { PlateElementProps } from 'platejs/react';
import { PlateElement } from 'platejs/react';

export const LinkElement = (props: PlateElementProps<TLinkElement>) => {
  const element = props.element as TLinkElement;
  // Determine whether the link should be rendered as a button.
  // We support a custom `renderType` field saved on the link element node.
  // It is expected to be set to 'button' when the user enables the "As button" switch
  // in the floating link toolbar.
  const isButton = (element as any).renderType === 'button';
  const { props: linkProps } = useLink({ element });
  return (
    <PlateElement
      {...props}
      {...linkProps}
      as="a"
      className={cn(
        isButton
          ? 'bg-primary-500 rounded-lg px-4 py-2 text-white'
          : 'text-primary decoration-primary font-medium underline underline-offset-4',
      )}
      data-render-type={isButton ? 'button' : undefined}
      attributes={{
        ...props.attributes,
        ...getLinkAttributes(props.editor, props.element),
        onMouseOver: (e) => {
          e.stopPropagation();
        },
      }}
    >
      {props.children}
    </PlateElement>
  );
};
